<template>
  <footer class="footer">
    <div class="container footer-shell">
      <div class="footer-content">
        <div class="footer-info-card">
          <div class="footer-logo-row">
            <div class="footer-logo-box">
              <img src="/images/logo2.png" alt="公司Logo" class="logo-image" />
            </div>
            <div class="footer-brand-copy">
              <h3 class="logo-text">{{ displayInfo.companyName }}</h3>
              <p class="footer-brand-subtitle">Papermaking New Materials Solution Provider</p>
            </div>
          </div>
          <p class="footer-description">
            {{ displayInfo.descriptionText }}
          </p>
          <div class="footer-social">
            <a href="#" class="social-link" aria-label="微信公众号">
              <i class="el-icon-chat-line-square"></i>
            </a>
            <a href="#" class="social-link" aria-label="商务邮箱">
              <i class="el-icon-message"></i>
            </a>
            <a href="#" class="social-link" aria-label="联系电话">
              <i class="el-icon-phone-outline"></i>
            </a>
          </div>
        </div>

        <div class="footer-card">
          <h4 class="footer-title">联系我们</h4>
          <ul class="contact-list">
            <li class="contact-item">
              <span class="contact-label">地址</span>
              <span class="contact-text">{{ displayInfo.address }}</span>
            </li>
            <li class="contact-item">
              <span class="contact-label">电话</span>
              <span class="contact-text">{{ displayInfo.phone }}</span>
            </li>
            <li class="contact-item">
              <span class="contact-label">邮箱</span>
              <span class="contact-text">{{ displayInfo.email }}</span>
            </li>
          </ul>
        </div>

        <div class="footer-card footer-links-card">
          <h4 class="footer-title">快速链接</h4>
          <ul class="links-list">
            <li class="link-item">
              <router-link to="/" class="link-text">首页</router-link>
            </li>
            <li class="link-item">
              <router-link to="/product" class="link-text">产品中心</router-link>
            </li>
            <li class="link-item">
              <router-link to="/about" class="link-text">关于我们</router-link>
            </li>
            <li class="link-item">
              <router-link to="/contact" class="link-text">联系我们</router-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-nav">
          <a href="#" class="footer-nav-link">隐私政策</a>
          <a href="#" class="footer-nav-link">服务条款</a>
          <a href="#" class="footer-nav-link">网站地图</a>
          <a
            href="https://beian.miit.gov.cn/"
            class="footer-nav-link footer-nav-link--record"
            target="_blank"
            rel="noopener noreferrer"
          >
            粤ICP备19016137号-1
          </a>
        </div>
        <p class="copyright">© {{ currentYear }} {{ displayInfo.companyName }}. 保留所有权利。</p>
      </div>
    </div>

    <transition name="fade">
      <button
        v-if="showBackToTop"
        class="back-to-top-btn"
        @click="backToTop"
        aria-label="回到顶部"
      >
        <i class="el-icon-arrow-up"></i>
      </button>
    </transition>
  </footer>
</template>

<script>
import { api } from '@/utils/api';

export default {
  name: 'FooterInfo',
  data() {
    return {
      aboutData: {},
      currentYear: new Date().getFullYear(),
      showBackToTop: false
    };
  },
  computed: {
    displayInfo() {
      const descriptionText = '专注于造纸新材料研发与应用，为客户提供高质量的产品和解决方案。';
      return {
        companyName: this.aboutData.companyName || this.aboutData.title || '东莞市恒源造纸新材料有限公司',
        descriptionText,
        address: this.aboutData.address || '广东省东莞市中堂镇南潢路359号',
        phone: this.aboutData.phone || '13316661234(微信同号)',
        email: this.aboutData.email || 'hengyuan0769@163.com'
      };
    }
  },
  mounted() {
    this.fetchAboutInfo();
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async fetchAboutInfo() {
      try {
        const response = await api.about.getInfo();
        this.aboutData = response?.data || response || {};
      } catch (err) {
        console.error('获取页脚联系信息失败:', err);
        this.aboutData = {};
      }
    },
    handleScroll() {
      this.showBackToTop = window.pageYOffset > 300;
    },
    backToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
};
</script>

<style scoped>
.footer {
  position: relative;
  margin-top: 52px;
  padding: 7px 0 9px;
  background: transparent;
}

.footer::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(19, 59, 120, 0.04) 0%, rgba(27, 70, 138, 0.1) 100%);
  pointer-events: none;
}

.footer-shell {
  position: relative;
  z-index: 1;
  padding: 14px 20px 12px;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.68);
  background: var(--nav-surface-gradient);
  box-shadow: 0 20px 52px rgba(17, 48, 100, 0.1);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  overflow: hidden;
}

.footer-shell::before,
.footer-shell::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}

.footer-shell::before {
  top: -40px;
  right: -10px;
  width: 180px;
  height: 180px;
  background: radial-gradient(circle, rgba(47, 118, 255, 0.1) 0%, rgba(47, 118, 255, 0) 72%);
}

.footer-shell::after {
  left: -30px;
  bottom: -40px;
  width: 180px;
  height: 180px;
  background: radial-gradient(circle, rgba(101, 118, 244, 0.08) 0%, rgba(101, 118, 244, 0) 72%);
}

.footer-content,
.footer-bottom {
  position: relative;
  z-index: 1;
}

.footer-content {
  display: grid;
  grid-template-columns: 1.2fr 0.95fr 0.8fr;
  gap: 18px;
  margin-bottom: 18px;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(190, 206, 235, 0.55);
}

.footer-info-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-logo-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.footer-logo-box {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.94), rgba(239, 245, 255, 0.84));
  box-shadow: 0 10px 22px rgba(17, 48, 100, 0.08);
}

.logo-image {
  width: 46px;
  height: 46px;
  object-fit: contain;
}

.footer-brand-copy {
  min-width: 0;
}

.logo-text {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.35;
}

.footer-brand-subtitle {
  margin-top: 4px;
  color: var(--text-tertiary);
  font-size: 11px;
  letter-spacing: 0.08em;
}

.footer-description {
  color: var(--text-secondary);
  line-height: 1.75;
  font-size: 13px;
  margin: 0;
}

.footer-social {
  display: flex;
  gap: 10px;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: rgba(47, 118, 255, 0.08);
  color: var(--primary-color);
  transition: all 0.3s ease;
  font-size: 16px;
}

.social-link:hover {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 12px 24px rgba(47, 118, 255, 0.18);
}

.footer-title {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 16px 0;
}

.footer-title::after {
  content: '';
  margin-top: 8px;
  width: 42px;
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%);
}

.contact-list,
.links-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 2px 0;
  border-bottom: 1px solid rgba(190, 206, 235, 0.38);
}

.contact-item:first-child {
  padding-top: 0;
}

.contact-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.contact-label {
  color: var(--text-disabled);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.contact-text {
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 1.65;
  word-break: break-word;
}

.link-item + .link-item {
  margin-top: 10px;
}

.link-text {
  color: var(--text-secondary);
  font-size: 13px;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.link-text::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(47, 118, 255, 0.16);
  transition: all 0.3s ease;
}

.link-text:hover {
  color: var(--primary-color);
  transform: translateX(4px);
}

.link-text:hover::before {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
}

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
}

.footer-nav {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;
}

.footer-nav-link {
  display: inline-flex;
  align-items: center;
  color: var(--text-tertiary);
  font-size: 12px;
  line-height: 1.6;
  transition: color 0.3s ease;
}

.footer-nav-link--record {
  word-break: break-word;
}

.footer-nav-link:hover {
  color: var(--primary-color);
}

.copyright {
  color: var(--text-disabled);
  font-size: 12px;
  margin: 0;
}

.back-to-top-btn {
  position: fixed;
  bottom: 28px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 18px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  color: white;
  border: none;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 16px 28px rgba(47, 118, 255, 0.22);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 1000;
}

.back-to-top-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 20px 34px rgba(47, 118, 255, 0.3);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 992px) {
  .footer-content {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .footer {
    margin-top: 42px;
    padding-top: 12px;
  }

  .footer-shell {
    padding: 18px 18px 16px;
    border-radius: 22px;
  }

  .footer-logo-row,
  .footer-social,
  .footer-nav {
    justify-content: center;
  }

  .footer-info-card,
  .footer-card,
  .footer-bottom {
    text-align: center;
  }


  .footer-bottom {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .footer-nav {
    justify-content: center;
    row-gap: 8px;
  }

  .footer-nav-link--record {
    max-width: 100%;
    justify-content: center;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .footer {
    margin-top: 34px;
  }

  .footer-shell {
    padding: 16px 14px;
    border-radius: 18px;
  }

  .logo-text {
    font-size: 17px;
  }

  .footer-nav-link,
  .copyright {
    font-size: 12px;
  }

  .back-to-top-btn {
    width: 44px;
    height: 44px;
    font-size: 22px;
    bottom: 24px;
    right: 14px;
    border-radius: 16px;
  }
}
</style>